<footer  class="page-footer ">
    <img class="clouds" src='../../../assets/images/cloudsSmall.jpg'/>
</footer>
